export const emailRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
export const nameRegex = /^[a-zA-Zа-яА-Я\s-]+$/;
